module.exports = __webpack_public_path__ + "static/media/smiley.afa87d42.svg";